<template>
  <div class="container">

    <h1><i class="fa fa-television"></i> streaming providers</h1>
    <div v-if="streamingProviders" class="streaming-provider-info">
      <div>{{streamingProviders.length}} streaming providers</div>
    </div>
    <hr>



    <table style="width:100%">
      <thead>
        <tr style="border-bottom: 1px solid black;">
          <th>id</th>
          <th>name</th>
          <th>free</th>
          <th>ads</th>
          <th>flat<br>rate</th>
          <th>rent</th>
          <th>buy</th>
          <th>has<br>unique</th>
          <th>include<br>in<br>searches</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(provider) in streamingProviders" :key="provider._id" class="streaming-provider-table-row" :class="{'include-in-searches': provider.include_in_searches}">

          <td>
            {{provider.provider_id}}
          </td>

          <td>
            <img :src="provider.logo_path" class="watch-provider-icon"> {{provider.provider_name}}
          </td>

          <td>{{catalogCountText(provider, 'free')}}</td>
          <td>{{catalogCountText(provider, 'ads')}}</td>
          <td>{{catalogCountText(provider, 'flatrate')}}</td>
          <td>{{catalogCountText(provider, 'rent')}}</td>
          <td>{{catalogCountText(provider, 'buy')}}</td>
<!--          <td>{{provider.unique_films.length}}</td>-->
          <td><FilmLink v-if="provider.unique_films.length" :film_name="provider.unique_films.length" :film_id="provider.unique_films[0]"></FilmLink></td>
          <td><div :class="{checkbox: true, checked: provider.include_in_searches}" @click="toggleIncludeInSearches(provider)"></div></td>
        </tr>

      </tbody>
    </table>

  </div>
</template>


<script>
import axios from "axios";
import FilmLink from "@/components/FilmLink.vue";

export default {
  name: "AdminUsersPage",
  /* eslint-disable vue/no-unused-components */
  components: {FilmLink},
  data() {
    return {
      waitingForResponse: false,
      streamingProviders: null,
    }
  },
  created() {
    this.waitingForResponse = true;

    // get the schedule for the given provider
    axios.get(`/api/admin/streaming-providers`)
        .then(response => {
          //console.log(`GET /admin/streaming-providers`, response.data)
          this.streamingProviders = response.data;
          this.streamingProviders.forEach(prov => {
            prov.flatCatalog = [ ...new Set([
              ...prov.catalog.free,
              ...prov.catalog.ads,
              ...prov.catalog.flatrate,
              ...prov.catalog.rent,
              ...prov.catalog.buy,
            ])];
            prov.catalogSize = prov.flatCatalog.length;
            prov.unique_films = prov.unique_films || [];
          });

          //console.log(this.streamingProviders);

          // this.streamingProviders.sort((provA, provB) => {
          //   return provA.display_priority - provB.display_priority;
          // });
          this.streamingProviders.sort((provA, provB) => {
            return provB.catalogSize - provA.catalogSize;
          });


        })
        .catch((err) => {
          console.error(`error calling /api/admin/streaming-providers : ${err}`)
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
  },
  methods: {

    async toggleIncludeInSearches(_provider) {

      return axios.post(`/api/admin/streaming-providers/set-include-in-searches`, {
        provider_id: _provider.provider_id,
        set: !_provider.include_in_searches
      })
          .then(response => {

            const updatedProvider = response.data;

            const provIndex = this.streamingProviders.findIndex(prov => prov.provider_id === updatedProvider.provider_id);
            this.streamingProviders[provIndex] = updatedProvider;
            this.streamingProviders[provIndex].flatCatalog = [ ...new Set([
              ...updatedProvider.catalog.free,
              ...updatedProvider.catalog.ads,
              ...updatedProvider.catalog.flatrate,
              ...updatedProvider.catalog.rent,
              ...updatedProvider.catalog.buy,
            ])];
            this.streamingProviders[provIndex].catalogSize = this.streamingProviders[provIndex].flatCatalog.length;

            this.streamingProviders.sort((provA, provB) => {
              return provB.catalogSize - provA.catalogSize;
            });

          })
          .catch(err => {
            console.error(`error calling /api/admin/streaming-providers/set-include-in-searches : ${err}`)
          })

    },

    dateDisplayString(_date) {
      const dateObj = ( _date instanceof Date )? _date : new Date(_date);
      return dateObj.toDateString();
    },

    catalogCountText(_provider, _key) {
      if ( !_provider?.catalog?.[_key]?.length ) {
        return '•';
      }
      return String(_provider.catalog[_key].length);
    }

  }
}
</script>


<style scoped>

.streaming-provider-info {
  margin-left: 50px;
  margin-right: 50px;
}

.streaming-provider-table-row {
  height: 2em;
  border-bottom: var(--bs-secondary-color);

  &:nth-child(even) {
    background-color: var(--bs-secondary-bg);
  }

  a {
    text-decoration: inherit;
  }

}

.roll-icons {
  text-align: center;

  .fa {
    padding: 0 2px 0 2px;

    &.fa-wrench {
      color: crimson;
    }

    &.fa-heartbeat {
      color: blue
    }
  }
}

.watch-provider-icon {
  width: 1.5em;
  height: 1.5em;
  border-radius: 25%;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-right: 2px;
  margin-left: 2px;
}

.checkbox {
  border-style: solid;
  border-radius: 50%;
  height: 15px;
  width: 15px;

  &.checked {
    background-color: var(--mol-color-gold);
  }

}

.include-in-searches {

  font-weight: 1000;
}




</style>